import React from 'react'
import { Dayjs } from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import 'dayjs/locale/pt-br'

type Props = {
  date: Dayjs | null
  setDate: React.Dispatch<React.SetStateAction<Dayjs | null>>
}

const DateInput: React.FC<Props> = ({ date, setDate }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <DatePicker
        value={date}
        onChange={(newValue) => setDate(newValue)}
        label="Data"
        sx={{ width: '270px' }}
      />
    </LocalizationProvider>
  )
}

export default DateInput
